export function* serialNumberGenerator(): Generator {
  let serialNumber = 0;

  while (true) {
    yield ++serialNumber;
  }
}
